import { render, staticRenderFns } from "./VerJurados.vue?vue&type=template&id=52a10c6b&scoped=true"
import script from "./VerJurados.vue?vue&type=script&lang=js"
export * from "./VerJurados.vue?vue&type=script&lang=js"
import style0 from "./VerJurados.vue?vue&type=style&index=0&id=52a10c6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a10c6b",
  null
  
)

export default component.exports